import React from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';

import withSettings from '../../../utils/withSettings';
import styles from '../styles/simcardsTableHeader';
import { translate } from '../../../i18n/I18nProvider';

const SimcardsTableHeader = ({ classes, settings, category = 'IoT' }) => {
  const isIoT = category === 'IoT';

  return (
    <div
      className={classes.headerRoot}
      style={{ color: settings.colors.primary }}
    >
      <div className={classes.label}>
        <i
          className={clsx(
            isIoT ? 'fas fa-sim-card' : 'fas fa-broadcast-tower',
            classes.icon
          )}
        ></i>
        <div className={classes.title}>
          {translate(
            isIoT
              ? 'MENU.IOT_SUBSCRIPTIONS'
              : 'MENU.MOBILE_BROADBAND_SUBSCRIPTIONS'
          )}
        </div>
      </div>
    </div>
  );
};

export default flowRight(withSettings, withStyles(styles))(SimcardsTableHeader);
